module.exports = __webpack_public_path__ + "assets/img/kyocera.ec097379.png";